import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hbb-calendar-title" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("上个月")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("今天")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("下个月")
const _hoisted_5 = { class: "con hbb-calendar" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "hbb-calendar-footer" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("确认")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_calendar = _resolveComponent("el-calendar")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["hbb-vacation-calendar-modal", {
      needScroll: _ctx.getNeedScroll,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createVNode(_component_el_date_picker, {
          modelValue: _ctx.currentDate,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentDate) = $event)),
          type: "month",
          placeholder: "选择日期"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectTabDate('prev-month')))
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectTabDate('today')))
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectTabDate('next-month')))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_calendar, {
        modelValue: _ctx.currentDate,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.currentDate) = $event))
      }, {
        dateCell: _withCtx((slotProps) => [
          _createElementVNode("div", {
            class: _normalizeClass(["calendar-day", {
              allSelected:
                _ctx.getDayData(slotProps.data.day).amSelected &&
                _ctx.getDayData(slotProps.data.day).pmSelected,
              allDeselected:
                _ctx.hasItBeenSelected(slotProps.data.day) &&
                !_ctx.getDayData(slotProps.data.day).amSelected &&
                +_ctx.getDayData(slotProps.data.day).leaveAm &&
                +_ctx.getDayData(slotProps.data.day).leavePm &&
                !_ctx.getDayData(slotProps.data.day).pmSelected,
            }])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["day-am", {
                selected:
                  _ctx.hasItBeenSelected(slotProps.data.day) &&
                  _ctx.getDayData(slotProps.data.day).amSelected,
                deselected:
                  _ctx.hasItBeenSelected(slotProps.data.day) &&
                  +_ctx.getDayData(slotProps.data.day).leaveAm &&
                  !_ctx.getDayData(slotProps.data.day).amSelected &&
                  !_ctx.getDayData(slotProps.data.day).pmSelected,
                isCancel:
                  _ctx.hasItBeenSelected(slotProps.data.day) &&
                  +_ctx.getDayData(slotProps.data.day).leaveAm,
              }]),
              onClick: ($event: any) => (_ctx.cellClick(_ctx.currentType, slotProps))
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(["day", {
                  dayFFF:
                    _ctx.hasItBeenSelected(slotProps.data.day) &&
                    _ctx.getDayData(slotProps.data.day).amSelected &&
                    _ctx.getDayData(slotProps.data.day).pmSelected,
                }]),
                onClick: _withModifiers(($event: any) => (_ctx.dateClick(slotProps)), ["stop"])
              }, _toDisplayString(slotProps.data.day.split("-").slice(2).join("-")), 11, _hoisted_7),
              _createElementVNode("span", {
                class: _normalizeClass({
                  all:
                    _ctx.getDayData(slotProps.data.day).amSelected &&
                    _ctx.getDayData(slotProps.data.day).pmSelected,
                  allCancel:
                    _ctx.hasItBeenSelected(slotProps.data.day) &&
                    +_ctx.getDayData(slotProps.data.day).leaveAm &&
                    +_ctx.getDayData(slotProps.data.day).leavePm &&
                    !_ctx.getDayData(slotProps.data.day).amSelected &&
                    !_ctx.getDayData(slotProps.data.day).pmSelected,
                })
              }, _toDisplayString(_ctx.getDayData(slotProps.data.day).amSelected ||
                  +_ctx.getDayData(slotProps.data.day).leaveAm
                    ? "休"
                    : ""), 3)
            ], 10, _hoisted_6),
            _createElementVNode("div", {
              class: _normalizeClass(["day-pm", {
                selected: _ctx.getDayData(slotProps.data.day).pmSelected,
                deselected:
                  _ctx.hasItBeenSelected(slotProps.data.day) &&
                  _ctx.getDayData(slotProps.data.day).leavePm === '01' &&
                  !_ctx.getDayData(slotProps.data.day).amSelected &&
                  !_ctx.getDayData(slotProps.data.day).pmSelected,
                isCancel:
                  _ctx.hasItBeenSelected(slotProps.data.day) &&
                  +_ctx.getDayData(slotProps.data.day).leavePm,
              }]),
              onClick: ($event: any) => (_ctx.cellClick('bottom', slotProps))
            }, _toDisplayString(_ctx.getDayData(slotProps.data.day).pmSelected ||
                +_ctx.getDayData(slotProps.data.day).leavePm
                  ? "休"
                  : ""), 11, _hoisted_8)
          ], 2)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_el_button, { onClick: _ctx.sureCheckDate }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ], 2))
}